import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { Component,  Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TransactionDto } from '@dto/transactionDto';
import { TransactionSuccess } from '@enums/transaction-success.enum';
import { TableColumn } from '@models/tableColumn';
import { TableOptions } from '@models/tableOptions';
import { TransactionsService } from '@services/entity/transactions.service';
import { RouteDataService } from '@services/route-data/route-data.service';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';
import '@angular/localize/init';
import { CreateDeliveryNoteDialogContentComponent } from '@components/dialog/create-delivery-note-dialog-content/create-delivery-note-dialog-content.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { plainToClass } from 'class-transformer';
import { TableFilter } from '@models/tableFilter';
import { CreateDeliveryCSVDialogContentComponent } from '../../dialog/create-delivery-csv-dialog-content/create-delivery-csv-dialog-content.component';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent extends AbstractEntitiesTableComponent implements OnInit {

  public className = 'TransactionsComponent';

  @ViewChild('customerView') customerView: TemplateRef<any>;
  @ViewChild('userView') userView: TemplateRef<any>;

  public customerId: number;
  private chargingStationId: string;
  public entities: TransactionDto[];
  public isOperatorView: boolean;
  public filter: TableFilter;


  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@TransactionsColumn1:Trans-ID`, property: 'transactionId' },
    { columnDescription: $localize`:@@TransactionsColumn2:Status`, property: 'successMessage' },
    { columnDescription: $localize`:@@TransactionsColumn3:Grund`, property: 'reason' },
    { columnDescription: $localize`:@@TransactionsColumn4:Vorname`, property: 'userFirstName' },
    { columnDescription: $localize`:@@TransactionsColumn5:Nachname`, property: 'userLastName' },
    { columnDescription: $localize`:@@TransactionsColumn6:RFID`, property: 'rfidCardIdTag' },
    { columnDescription: $localize`:@@TransactionsColumn7:Ladestation`, property: 'chargingStationName' },
    { columnDescription: $localize`:@@TransactionsColumn8:kWh`, property: 'meterAmount', options: { isMeterValue: true } },
    // { columnDescription: $localize`:@@TransactionsColumn8:kWh`, property: 'meterAmount', options: { columnPipe: { pipe: new ThousandPipe(new DecimalPipe('de-DE')) } } },
    { columnDescription: $localize`:@@TransactionsColumn9:Anfang`, property: 'startTimestamp', options: { columnPipe: { pipe: new DEDatePipe() } } },
    { columnDescription: $localize`:@@TransactionsColumn10:Ende`, property: 'stopTimestamp', options: { columnPipe: { pipe: new DEDatePipe() } } },
    { columnDescription: $localize`:@@TransactionsColumn11:Dauer`, property: 'duration' },
  ];

  public tableOptions: TableOptions = { hideActions: true, showCheckboxes: false };

  constructor(
    public transactionsService: TransactionsService, private dialog: NgbModal, private routeDataService: RouteDataService, injector: Injector) {
    super(transactionsService, injector);
  }

  ngOnInit() {
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    if (this.authenticationService.userHasRole('Customer') || this.authenticationService.userHasRole('Operator') || this.authenticationService.userHasRole('User') || this.authenticationService.userHasRole('Account')) {
      this.tableOptions = { hideActions: true, showCheckboxes: true, rowRouterLink: '{id}' };
    }
    super.ngOnInit();

    let size = parseInt(localStorage.getItem(`${this.className}PageSize`))
    if (size) this.tableFunctions.pageSize = size;
    else this.tableFunctions.pageSize = 50;

    this.tableFunctions.sortColumn = 'id';
    this.tableFunctions.sortDirection = 'desc';
  }

  async initializeEntities() {
    if(this.isOperatorView) {
      this.customerId = this.activatedRoute.parent.snapshot.params.key;
    }
  }

  mapSuccessMessageAndQRCodeTag() {
    for (let transactionDto of this.entities) {
      transactionDto.successMessage = TransactionSuccess[transactionDto.success];
      if (transactionDto.paymentIntentId != null) transactionDto.rfidCardIdTag = 'QR-Code-Laden';
      if (transactionDto.isFreeCharge) transactionDto.rfidCardIdTag = 'Kostenloses Laden';
      if (transactionDto.sessionId != null) transactionDto.rfidCardIdTag = 'eRoaming-Laden';
      if (transactionDto.hecId != null) transactionDto.rfidCardIdTag = 'Terminal-Laden';
      if (transactionDto.userFirstName == null) transactionDto.userFirstName = '—'
      if (transactionDto.userLastName == null) transactionDto.userLastName = '—'
    }
  }

  matches(entity: TransactionDto, term: string) {
    return TransactionsService.matches(entity, term);
  }

  openCreateDeliveryNoteDialog() {
    const dialogRef = this.dialog.open(CreateDeliveryNoteDialogContentComponent, { centered: true, size: 'xl', backdrop: 'static' });
    dialogRef.componentInstance.transactions = this.tableFunctions.selectedEntities;
    dialogRef.componentInstance.customerId = this.customerId;

    dialogRef.result.then((result) => {

    }, (backdrop) => {

    });
  }

  determineTemplate() {
    if (this.authenticationService.userHasRole('Customer') || this.authenticationService.userHasRole('Operator') || this.authenticationService.userHasRole('Account')) {
      return this.customerView;
    }
    else if (this.authenticationService.userHasRole('User')) {
      return this.userView;
    }
  }

  setFilter(filter: TableFilter) {
    filter.filterDLM = false;
    filter.filterSignal = false;
    this.filter = filter;
    this.updateTable();
  }

  openCreateDeliveryCSVDialog() {
    const dialogRef = this.dialog.open(CreateDeliveryCSVDialogContentComponent, { centered: true, size: 'xl', backdrop: 'static' });


    dialogRef.componentInstance.transactions = this.tableFunctions.selectedEntities;
    dialogRef.componentInstance.userId = null;

    dialogRef.result.then((result) => {

    }, (backdrop) => {

    });
  }

  async updateTable() {
    if(this.isOperatorView) {
      this.transactionsService.getTransactionsOfCustomer(this.customerId, this.filter).subscribe(result => {
        this.entities = plainToClass(TransactionDto, result)
        this.mapSuccessMessageAndQRCodeTag()
        super.setupTable()
      }, error => {
        this.messageService.setError(error);
      });
    } else {
      this.transactionsService.getTransactions(this.filter).subscribe(result => {
        this.entities = plainToClass(TransactionDto, result)
        this.mapSuccessMessageAndQRCodeTag()
        super.setupTable()
      }, error => {
        this.messageService.setError(error);
      });
    }
  }
}
